// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-sszsxxcx-index-main_right_content-1lpJR","table":"components-tjcx-sszsxxcx-index-table-3zH0d"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/sszsxxcx/index.css
// module id = 2318
// module chunks = 0